import { Button, Space, Table, Input, Modal, Form, InputNumber, Pagination } from 'antd';
import { useContext, useEffect, useState } from 'react';
import Loading from '../../../components/loader';
import { PageContext } from '../../../lib/context';
import BillsInformation from './information';

const PaymentsView = () => {
  const { subscribers, usersColumns, visible, handleSearch, setVisible, displayAmount, _onFinish, form, loading, limit, offset, total, current, handlePaginationChange, } = useContext(PageContext);
  const { Search } = Input;

  return (
    <div>
      <div className="flex flex-col px-10">
        <div className="items-start align-start">
          <p className="text-3xl font-bold">Create Payments</p>
        </div>
        <div className="flex flex-row mb-5">
          <Space>
            <div className="flex flex-row">
              <div className="mr-20">
                <Input.Search
                  placeholder="Search by ID or Lastname"
                  style={{ width: 500 }}
                  enterButton
                  onSearch={handleSearch}
                  allowClear
                  size="large"
                />
              </div>
            </div>
          </Space>
        </div>
        <div className="flex flex-row">
          <div className="w-full mr-3">
            {loading ? (
              <div className="mt-32">
                <Loading show={loading} />
              </div>
            ) : (
              <>
                <Table dataSource={subscribers} columns={usersColumns} pagination={false} />
                <Pagination
                  onChange={handlePaginationChange}
                  current={current}
                  pageSize={limit}
                  total={total}
                />
              </>
            )
            }
          </div>
        </div>
        <div>
          <Modal
            title="Bill Information"
            centered
            visible={visible}
            onCancel={() => setVisible(false)}
            width={1000}
            footer={
              <div style={{ textAlign: 'left' }}>
                <Form form={form} onFinish={_onFinish} layout="vertical">
                  {displayAmount && <>
                    <Form.Item name="amount" rules={[{ required: true, message: "Amount is required" }]} label="Enter Amount">
                      <div className="mb-2">
                        <InputNumber placeholder="Enter Amount" style={{ width: 350 }} />
                      </div>
                    </Form.Item>
                    <Form.Item hidden={true} name="billing_id">
                      <InputNumber />
                    </Form.Item>
                    <Form.Item hidden={true} name="subscriber_id">
                      <InputNumber />
                    </Form.Item>
                    <Form.Item>
                      <Button type="primary" htmlType="submit">
                        Submit
                      </Button>
                    </Form.Item>
                  </>}
                </Form>
              </div>
            }>
            <BillsInformation />
          </Modal>
        </div>
      </div>
    </div>

  );
};

export default PaymentsView;